import attendanceDetail from '@/api/report/attendance-detail'
import { baseState, baseMutations } from '@/store/mixins'
import { join, split } from 'lodash'

export const state = {
  ...baseState,
  orgChartStructures: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_ORG_CHART_STRUCTURE(state, data) {
    state.orgChartStructures = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: join(attributes.dateRange, ',')
        }
      },
      attributes
    )
    return attendanceDetail.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  async getOrgChartStructure(context, attributes = {}) {
    let response = await attendanceDetail.orgChartStructure({
      params: attributes
    })
    context.commit('SET_ORG_CHART_STRUCTURE', response.data)
  },

  exportExcel(context, data) {
    return attendanceDetail.exportExcel(data)
  }
}